<div class="container-fluid mt-3">
    <h5>{{ title }}</h5>
    <p class="text-muted">
        Trazabilidad interna de donativos recibidos (donante, importe, medio de pago). No genera el fichero de
        presentación oficial de la AEAT.
    </p>

    <mat-spinner *ngIf="isLoading" diameter="30"></mat-spinner>

    <table class="table table-striped table-sm" *ngIf="!isLoading">
        <thead>
            <tr>
                <th>NIF</th>
                <th>Nombre</th>
                <th>Tipo</th>
                <th>Fecha factura</th>
                <th>Importe</th>
                <th>Medio de pago</th>
                <th>Fecha de cobro</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of rows">
                <td>{{ row.nif }}</td>
                <td>{{ row.nombre }}</td>
                <td>{{ tipoLabel(row.tipoIngreso) }}</td>
                <td>{{ row.fecha | date:'dd/MM/yyyy' }}</td>
                <td>{{ row.importe | number:'1.2-2' }} €</td>
                <td>{{ row.medioPago || '—' }}</td>
                <td>{{ row.fechaCobro ? (row.fechaCobro | date:'dd/MM/yyyy') : 'Pendiente' }}</td>
            </tr>
            <tr *ngIf="rows.length === 0">
                <td colspan="7" class="text-center text-muted">No hay donativos registrados en este ejercicio</td>
            </tr>
        </tbody>
    </table>
</div>
